<template>
  <div class="edit-table">
    <div class="padding_50">
      <vxe-toolbar v-if="!disabled">
        <template v-slot:buttons>
          <vxe-button @click="productNameClick()" >添加码值</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table :data="barCodeList">
        <vxe-table-column min-width="100" field="barCode" title="箱码">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="productCode" title="产品编码">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="productName" title="产品名称">
        </vxe-table-column>
        <vxe-table-column
          title="操作"
          width="100"
          show-overflow
          v-if="!disabled"
          key="操作"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" size="mini" @click="deletRow(row, rowIndex)">删除</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'configProducts',
  components: {
    SelectConfig,
  },
  props: {
    value: Array,
    disabled: Boolean,
    customerCode: String,
    productCode: String,
  },
  watch: {
    value: {
      handler(val) {
        this.barCodeList = val || [];
      },
      deep: true,
    },
    disabled(val) {
      console.log('🚀 ~ disabled ~ val:', val);
    },
  },
  data() {
    return {
      barCodeList: [], // 当前关联费用科目数据
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.barCodeList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log(this.barCodeList, 'barCodeList');
        this.barCodeList.splice(rowIndex, 1);
        this.$emit('input', this.barCodeList);
      });
    },
    deleteTable() {
      this.barCodeList = [];
      this.$emit('input', []);
    },
    // 打开点击弹窗产品名称
    productNameClick(index) {
      if (!this.customerCode) {
        this.$message.error('请先选择经销商');
        return false;
      }
      if (!this.productCode) {
        this.$message.error('请先选择产品');
        return false;
      }
      const params = {
        data: this.barCodeList,
        selectionList: [],
        functionCode: 'barCodeList',
        idKey: 'barCode',
        noReset: true,
        paramData: {
          customerCode: this.customerCode,
          productCode: this.productCode,
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      const data = this.getReset(val, [], 'barCode');
      this.barCodeList = this.getReset(this.barCodeList.concat(data), [], 'barCode');
      this.barCodeList = this.barCodeList.map((item) => ({
        barCode: item.barCode,
        barCodeType: item.barCodeType,
        productName: item.productName,
        productCode: item.productCode,
      }));
      this.$emit('input', this.barCodeList);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },

  },
};
</script>

<style lang="less" scoped>
  .edit-table {
    padding-left: 50px;
    margin-left: 0 !important;
  }
</style>
